import { Paperclip } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useItemAttachmentCount, type ItemType } from "@/hooks/useAttachments";
import { cn } from "@/lib/utils";

interface AttachmentsBadgeProps {
  tripId: string;
  itemType: ItemType;
  itemIndex: number;
  onClick?: () => void;
  className?: string;
}

export function AttachmentsBadge({
  tripId,
  itemType,
  itemIndex,
  onClick,
  className,
}: AttachmentsBadgeProps) {
  const { data: count, isLoading } = useItemAttachmentCount(tripId, itemType, itemIndex);

  // Don't show anything if no attachments
  if (isLoading || !count || count === 0) {
    return null;
  }

  return (
    <Badge
      variant="secondary"
      className={cn(
        "cursor-pointer hover:bg-secondary/80 transition-colors gap-1",
        className
      )}
      onClick={onClick}
    >
      <Paperclip className="h-3 w-3" />
      {count}
    </Badge>
  );
}
